import React from 'react';

export const TaskListEmptyState = ({
    hasActiveFilters,
    onResetFilters,
}) => {
    return (
        <div className="d-flex flex-column align-items-center justify-content-center text-center py-5 px-3 border border-dashed border-gray-5 rounded-3 bg-light">
            <div className="wd-60 ht-60 rounded-circle bg-soft-primary text-primary d-flex align-items-center justify-content-center mb-3">
                <i className="bi bi-inbox fs-4" />
            </div>
            <h6 className="fw-bold mb-1">
                {hasActiveFilters ? 'No hay resultados para tus filtros' : 'Aún no hay tickets registrados'}
            </h6>
            <p className="text-muted mb-3" style={{ maxWidth: '420px' }}>
                {hasActiveFilters
                    ? 'No encontramos tickets con los criterios actuales. Limpia los filtros para volver a ver todos los registros.'
                    : 'Todavía no se han creado tickets en este tablero. Cuando existan, aparecerán aquí automáticamente.'}
            </p>
            <button
                type="button"
                className="btn btn-light-brand btn-sm"
                onClick={onResetFilters}
                disabled={!hasActiveFilters}
            >
                {hasActiveFilters ? 'Limpiar filtros' : 'Sin filtros activos'}
            </button>
        </div>
    );
};
